var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C6.05436 10 6.91817 10.8159 6.99451 11.8507L7 12V15C7 16.0544 6.18412 16.9182 5.14926 16.9945L5 17H2C0.945638 17 0.0818349 16.1841 0.00548577 15.1493L0 15V12C0 10.9456 0.815877 10.0818 1.85074 10.0055L2 10H5ZM5 0C6.10457 0 7 0.89543 7 2V5C7 6.10457 6.10457 7 5 7H2C0.89543 7 0 6.10457 0 5V2C0 0.89543 0.89543 0 2 0H5Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C15 14.4477 14.5523 14 14 14H10L9.88338 14.0067C9.38603 14.0645 9 14.4872 9 15C9 15.5523 9.4477 16 10 16H14L14.1166 15.9933C14.614 15.9355 15 15.5128 15 15Z",
    fill: "#DA7D4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19 10.4477 18.5523 10 18 10H10C9.4477 10 9 10.4477 9 11C9 11.5523 9.4477 12 10 12H18C18.5523 12 19 11.5523 19 11Z",
    fill: "#DA7D4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5C15 4.44772 14.5523 4 14 4H10L9.88338 4.00673C9.38603 4.06449 9 4.48717 9 5C9 5.55228 9.4477 6 10 6H14L14.1166 5.99327C14.614 5.93551 15 5.51283 15 5Z",
    fill: "#DA7D4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1C19 0.44772 18.5523 0 18 0H10L9.88338 0.0067277C9.38603 0.0644934 9 0.487169 9 1C9 1.55228 9.4477 2 10 2H18L18.1166 1.99327C18.614 1.93551 19 1.51283 19 1Z",
    fill: "#DA7D4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavEvents);
export default __webpack_public_path__ + "static/media/nav_events.d3f9f3680741aa6c0aff9b19a65e36f2.svg";
export { ForwardRef as ReactComponent };